import { RESET_STATE, START_SPINNER, STOP_SPINNER, ACTION_LOGOUT_INITIATED } from '../actions/types';

const initialState = {
	spinner: 0,
};

export default function (state = initialState, action) {
	switch (action.type) {
		case RESET_STATE:
			return initialState;

		case START_SPINNER:
			return {
				...state,
				spinner: state.spinner + 1,
			};

		case STOP_SPINNER:
			return {
				...state,
				spinner: state.spinner - 1,
			};
		
		case ACTION_LOGOUT_INITIATED:
			return initialState;	
		
		default:
			return state;
	}
}
